import { useParams } from 'react-router-dom';
import { Cta } from '@/components/landing/Cta';
import { FaqList } from '@/components/landing/FaqList';
import { NotFound } from '@/pages/NotFound';
import { findTool } from '@/lib/tools';

/**
 * Le gabarit générique de toutes les pages outil : hero centré -> widget ->
 * CTA vers le produit payant -> description -> FAQ. C'est le funnel verrouillé
 * (voir `.dispatchseo/conventions.md`) : chaque futur outil rejoue ce même
 * gabarit, seul le contenu du registre (`lib/tools.tsx`) change.
 */
export function ToolPage() {
  const { slug } = useParams();
  const tool = slug ? findTool(slug) : undefined;
  if (!tool) return <NotFound />;

  const Widget = tool.Widget;

  return (
    <>
      <section className="nz-tool-hero">
        <div className="nz-eyebrow">Outil gratuit</div>
        <h1 className="nz-tool-hero__title">{tool.h1}</h1>
        <p className="nz-lead">{tool.valueLine}</p>
      </section>

      <section className="nz-tool-widget">
        <Widget />
      </section>

      <Cta />

      <section className="nz-tool-page">
        <div className="nz-prose">
          <h2>{tool.descriptionTitle}</h2>
          {tool.description.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>

        {tool.faq.length > 0 ? (
          <div className="nz-faq-group">
            <h2 className="nz-faq-group__title">Questions fréquentes</h2>
            <FaqList items={tool.faq} idPrefix={`tool-${tool.slug}`} openFirst={false} />
          </div>
        ) : null}
      </section>
    </>
  );
}
